<script>
export default {
  name: 'SecurePayDepositFrame',
  props: {
    paymentUrl: { type: String, required: true },
    transaction: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      iframeLoaded: false
    }
  },
  computed: {
    safePaymentUrl () {
      try {
        const paymentUrl = new URL(String(this.paymentUrl || '').trim())
        return paymentUrl.protocol === 'https:' ? paymentUrl.href : ''
      } catch (error) {
        return ''
      }
    },
    accountType () {
      return String(this.transaction.account_type || this.transaction.accountType || '').trim().toUpperCase()
    },
    isPromptPay () {
      const qrCodeText = this.transaction.qr_code_text || this.transaction.qrCodeText || ''
      return this.accountType === 'PROMPTPAY' || (!this.accountType && Boolean(String(qrCodeText).trim()))
    },
    paymentTitle () {
      if (this.isPromptPay) return 'ชำระเงินผ่าน QR Code'
      if (this.accountType === 'MANUAL_BANK') return 'ชำระเงินผ่านบัญชีธนาคาร'
      return 'ชำระเงินผ่าน SecurePay'
    }
  },
  watch: {
    safePaymentUrl () {
      this.iframeLoaded = false
    }
  },
  methods: {
    handleFrameLoad () {
      this.iframeLoaded = true
    }
  }
}
</script>

<template>
  <section class="securepay-frame" aria-live="polite">
    <header class="securepay-frame__header">
      <strong>{{ paymentTitle }}</strong>
      <span>{{ iframeLoaded ? 'รอผลการชำระเงิน' : 'กำลังโหลด' }}</span>
    </header>

    <div class="securepay-frame__body">
      <div v-if="safePaymentUrl && !iframeLoaded" class="securepay-frame__loading" role="status">
        <i class="fas fa-spinner fa-spin" aria-hidden="true" />
        <span>กำลังโหลดหน้าชำระเงิน SecurePay</span>
      </div>
      <iframe
        v-if="safePaymentUrl"
        :key="safePaymentUrl"
        class="securepay-frame__iframe"
        :src="safePaymentUrl"
        title="หน้าชำระเงิน SecurePay"
        loading="eager"
        referrerpolicy="strict-origin-when-cross-origin"
        allow="camera; microphone; fullscreen; clipboard-read; clipboard-write; payment"
        @load="handleFrameLoad"
      />
      <div v-else class="securepay-frame__error" role="alert">
        ไม่สามารถโหลดลิงก์ชำระเงิน SecurePay ได้
      </div>
    </div>

    <footer class="securepay-frame__note">
      <template v-if="isPromptPay">
        <div>สแกน QR Code ด้วยแอปธนาคารและชำระตามยอดที่แสดง</div>
        <strong>ระบบตรวจสอบสถานะให้อัตโนมัติ ไม่ต้องอัปโหลดสลิป</strong>
      </template>
      <template v-else-if="accountType === 'MANUAL_BANK'">
        <div>โอนเงินตามข้อมูลที่แสดง แล้วอัปโหลดสลิปภายในหน้า SecurePay</div>
        <strong>หากปิดหน้าต่าง สามารถกลับมาทำรายการเดิมต่อได้จากปุ่มฝากเงิน</strong>
      </template>
      <template v-else>
        <div>ทำตามขั้นตอนการชำระเงินที่แสดงในหน้า SecurePay</div>
        <strong>ระบบจะตรวจสอบสถานะรายการให้อัตโนมัติ</strong>
      </template>
    </footer>
  </section>
</template>

<style scoped>
.securepay-frame {
  overflow: hidden;
  border-radius: 10px;
  background: #111827;
  color: #fff;
  font-family: 'Kanit', sans-serif;
}
.securepay-frame__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: #0f172a;
}
.securepay-frame__header strong {
  color: #86efac;
  font-size: 15px;
}
.securepay-frame__header span {
  color: #cbd5e1;
  font-size: 12px;
}
.securepay-frame__body {
  position: relative;
  min-height: 560px;
  height: calc(100vh - 245px);
  background: #fff;
}
.securepay-frame__iframe {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
.securepay-frame__loading,
.securepay-frame__error {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  color: #334155;
  text-align: center;
}
.securepay-frame__loading i {
  color: #2563eb;
  font-size: 30px;
}
.securepay-frame__error {
  color: #b91c1c;
}
.securepay-frame__note {
  padding: 12px 14px;
  background: #fff;
  color: #222;
  font-size: 14px;
  line-height: 1.55;
  text-align: center;
}
.securepay-frame__note strong {
  display: block;
  margin-top: 6px;
  color: #15803d;
}
@media (max-width: 575.98px) {
  .securepay-frame__body {
    height: calc(100vh - 235px);
    height: calc(100dvh - 235px);
    min-height: 480px;
  }
}
</style>
